module.exports = __webpack_public_path__ + "assets/amplitude.52fdb317.svg";